module.exports = __webpack_public_path__ + "static/img/kfz.e901314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/kfz.jpg
// module id = NjyW
// module chunks = 7 104 105 106 107